import apiClient from "./Api";
/**
 * Obtiene la lista de proyectos. Puede filtrar por título, tags, etc.
 * @returns {Promise} Array de proyectos
 */
export const getAttachments = async (element_uuid, referenced_by_type) => {
  // Endpoint swagger: GET /core/attachment/{element_uuid}/{attachment_type}
  if (!element_uuid) return [];
  const response = await apiClient.get(
    `/core/attachment/${element_uuid}/${referenced_by_type}`
  );
  return response.data;
};

export const uploadAttachment = async (element_uuid, formData) => {
  // Endpoint swagger: GET /core/attachment/{element_uuid}/{attachment_type}

  const response = await apiClient.post(
    `/core/attachment/upload/${element_uuid}`,
    formData
  );
  return response.data;
};

export const deleteAttachment = async (element_uuid) => {
  // Endpoint swagger: GET /core/attachment/{element_uuid}/{attachment_type}

  const response = await apiClient.delete(
    `/core/attachment/delete/${element_uuid}`
  );
  return response.data;
};
export const downloadAllAttachments = async (layer_uuid, project) => {
  try {
    const response = await apiClient.get(
      `/core/attachment/download-layer-attachments/${layer_uuid}`,
      {
        responseType: "blob",
      }
    );

    const filename = `adjuntos_${project?.title?.es}.zip`;

    // Create a blob URL and trigger a download
    const blob = new Blob([response.data], { type: "application/zip" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err) {
    if (err?.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        console.error("Download error payload:", text);
      } catch {}
    }
    console.error(err);
  }
};
